import {Box, Flex, Image, Text} from '@chakra-ui/react'
import {CommonColors} from '@utils/CommonStyles'
import renderTextWithLineBreaks from './shared/renderTextWithLineBreaks'
import CountdownTimer from './shared/CountdownTimer'
import {EXAM_MODE_TYPE, ExamPartType} from '@pages/ExamPage/examPageModel'
import PersonExamRoomImage from '@assets/images/exam/person-exam-room.png'
import {useLocation} from 'react-router-dom'
import {Input} from 'antd'

const {TextArea} = Input

function QuestionItem({
  data,
  questionList,
  showQuestion,
  isShowAnswer,
  isShowBtnContinue,
  handleTimePrepare,
  countdownTimerPart2Ref,
  audioRef,
}: any) {
  const location = useLocation()
  const {type} = location.state

  if (data?.type === ExamPartType.PART_TWO) {
    return (
      <Flex flex={1}>
        <Flex position={'relative'} w={'600px'} ml={'24px'} display={{ base: 'none', md: 'flex' }}>
          <Image
            maxH={'100%'}
            position={'absolute'}
            bottom={0}
            src={PersonExamRoomImage}
            objectFit={'contain'}
          />
        </Flex>
        {!isShowBtnContinue ? (
          <Flex 
            w={'100%'} 
            alignSelf={'flex-start'} 
            mt={'30px'} 
            h={'100%'}
            className="scroll-bar"
            overflow={'auto'}
            maxH={{base: 'calc(100vh - 200px)', md: 'none'}}
          >
            <Flex flexDirection={{base: 'column', md: 'row'}}>
              <Flex
                className="scroll-bar"
                overflow={'auto'}
                bg={CommonColors.white}
                w={{base: '100%', md: '448px'}}
                h={{base: 'calc(100vh - 250px)', md: 'auto'}}
                maxH={{base: 'none', md: '400px'}}
                borderRadius={24}
                padding={'20px'}
                mr={{base: '0', md: '16px'}}
                mb={{base: '16px', md: '0'}}
                flexDirection={'column'}>
                <Text color={CommonColors.blue} fontSize={{base: 18, md: 20, lg: 24}} fontWeight={600}>
                  Question
                </Text>
                <Text flex={1} fontSize={{base: 18, md: 20, lg: 24}}>
                  {questionList[showQuestion]?.question}
                </Text>
                {type === EXAM_MODE_TYPE.DEMO_TEST && (
                  <>
                    <Text alignSelf={'center'} fontSize={{base: 14, md: 15, lg: 16}}>
                      Bạn có 1 phút suy nghĩ, bài thi sẽ tự động bắt đầu sau{' '}
                    </Text>
                    <CountdownTimer
                      ref={countdownTimerPart2Ref}
                      onTimeEnded={handleTimePrepare}
                      initialTime={60}
                      textStyle={{
                        color: CommonColors.orange,
                        alignSelf: 'center',
                        fontSize: 18,
                        fontWeight: 400,
                      }}
                    />
                  </>
                )}
                <Box
                  mt={'16px'}
                  bgColor={'rgba(229, 242, 255, 0.5)'}
                  p={'16px'}
                  borderRadius={'20px'}>
                  <Box fontSize={{base: 14, md: 15, lg: 16}}>
                    {renderTextWithLineBreaks(data?.suggestion || '')}
                  </Box>
                </Box>
              </Flex>
              <Flex
                display={{base: 'none', md: 'flex'}}
                flexDirection={'column'}
                bg={CommonColors.white}
                w={'448px'}
                maxH={'400px'}
                borderRadius={24}
                padding={'20px'}>
                <Text
                  color={CommonColors.blue}
                  fontSize={{base: 18, md: 20, lg: 24}}
                  fontWeight={600}
                  textTransform={'uppercase'}
                  mb={'16px'}>
                  Notes
                </Text>
                <Box flex={1} sx={{'.ant-input': {h: '100% !important'}}}>
                  <TextArea
                    // style={{height:'100%'}}
                    maxLength={512}
                    placeholder=""
                    autoSize={{minRows: 8}}
                  />
                </Box>
              </Flex>
            </Flex>
          </Flex>
        ) : (
          <Flex w={'100%'} alignSelf={'flex-start'} mt={'50px'}>
            <Box
              bg={CommonColors.white}
              mt={'100px'}
              maxW={'700px'}
              borderRadius={24}
              padding={'20px'}
              boxShadow={
                '0px 0px 8px 0px rgba(20, 20, 20, 0.08), 0px 0px 1px 0px rgba(20, 20, 20, 0.04)'
              }>
              <Text fontSize={{base: 16, md: 18, lg: 20}} fontWeight={400} textAlign={'left'}>
                Bạn đã hoàn thành phần thi này
              </Text>
            </Box>
          </Flex>
        )}
      </Flex>
    )
  }
  return (
    <Flex flex={1}>
      <Flex position={'relative'} w={'600px'} ml={'24px'} display={{ base: 'none', md: 'flex' }}>
        <Image
          maxH={'100%'}
          position={'absolute'}
          bottom={0}
          src={PersonExamRoomImage}
          objectFit={'contain'}
        />
      </Flex>
      <Flex w={'100%'} alignSelf={'flex-start'} mt={'50px'}>
        <Box
          bg={CommonColors.white}
          mt={'100px'}
          maxW={'700px'}
          borderRadius={24}
          padding={'20px'}
          boxShadow={
            '0px 0px 8px 0px rgba(20, 20, 20, 0.08), 0px 0px 1px 0px rgba(20, 20, 20, 0.04)'
          }>
          <Text fontSize={{base: 16, md: 18, lg: 20}} fontWeight={400} textAlign={'left'}>
            {isShowBtnContinue
              ? 'Bạn đã hoàn thành phần thi này'
              : questionList[showQuestion]?.question}
          </Text>
          <audio ref={audioRef} />
        </Box>
      </Flex>
    </Flex>
  )
}

export default QuestionItem
